import axios from "axios";

const MAIN_API_URL = process.env.REACT_APP_API_BASE_URL;
export const getGreenEnergyTransactionsData = (meterType: number) => {
  return axios
    .get(`${MAIN_API_URL}/admin/transactions/usage?meterType=${meterType}`)
    .then((response) => {
      return response.data;
    }).catch(error => {
      console.log(error)
    });
};

export const getGreenAttributeTracking = (date: string, secondDate: string, period: string, meterType: number, userId?: number) => {
  return axios
    .get(`${MAIN_API_URL}/admin/distribution/tracking?date=${date}&secondDate=${secondDate}&period=${period}&meterType=${meterType}&userId=${userId}`)
    .then((response) => {
      return response.data;
    });
};

export const getProsumerList = () => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/admin/prosumers`)
    .then((response) => {
      return response.data;
    });
};

export const getGreenEnergyTransactionsDataByID = (prosumerID: number, meterType: number) => {
  return axios
    .get(`${MAIN_API_URL}/admin/${prosumerID}/transactions/usage?meterType=${meterType}`)
    .then((response) => {
      return response.data;
    }).catch(error => {
      console.log(error)
    });
};

export const getProductionData = (date: string, period: string, meterType: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/admin/transactions/production?period=${period}&date=${date}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    });
};

export const getTransactionsData = (date: string, meterType: number) => {
  return axios
    .get(`${MAIN_API_URL}/admin/transactions/daily-summery?date=${date}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    });
};

export const getTransactions = (startDate: string, userIds: number[], userType: string, isConsumption?: boolean) => {
  const consumptionParam = (isConsumption) ? `&isConsumption=${isConsumption}` : ``;
  const URL = `${MAIN_API_URL}/admin/transactions?startDate=${startDate}&userIds=${userIds}&userType=${userType}${consumptionParam}`
  return axios
    .get(URL)
    .then((response) => {
      return response.data;
    });
};